// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"f1277165","587":"d2906e63"}[chunkId] + ".chunk.css";
};